/*
 * FOR SALE — filtres et pagination de la page Avis (/pages/avis, section fs-reviews-page, décision 014). Liquid rend tous
 * les avis, du plus récent au plus ancien ; un script en ligne masque déjà, avant l'affichage, ceux qui ne sont pas sur la
 * page et dans le filtre demandés. Ce script pose :
 *  - les filtres (puces à bascule, aria-pressed, avec le nombre d'avis rendus écrit par Liquid) : une note (« Toutes les
 *    notes », 5 à 1 ★), « Achats vérifiés », et un jeu quand la page en propose (au moins 5 achats vérifiés, liste
 *    data-fs-rp-games ; un jeu implique « Achats vérifiés »). Un filtre masque, il ne trie jamais : l'ordre reste du
 *    plus récent au plus ancien ;
 *  - le compteur (aria-live, annoncé seulement après une action, jamais au chargement) : « 137 avis », « 5 avis à 4 étoiles », « 12 avis « Achat vérifié » »… et, sans résultat, la
 *    phrase d'état du document de contenu avec « Voir toutes les notes » (ou « Voir tous les avis ») ;
 *  - l'adresse : ?page=N (borné), ?note=N, ?verifie=1, ?jeu=<jeu> lus au chargement et réécrits par replaceState (?page=1
 *    retiré) ; chaque changement de page ou de filtre ajoute une entrée (pushState) ; le retour arrière les rétablit ;
 *  - la navigation : « Plus récents », numéros (premier, dernier, voisins, ellipses), « Plus anciens » ; vrais liens
 *    (nouvel onglet, copie), aria-current="page" sur la page affichée, rel prev / next ;
 *  - le titre de la liste : « · page N sur M » ; au changement de page, focus sur ce titre (lu par les lecteurs d'écran)
 *    et défilement jusqu'à lui (direct si prefers-reduced-motion). Un changement de filtre garde le focus sur son bouton.
 * Sans ce script : la page et le filtre demandés restent appliqués par le script en ligne, sans commandes ; sans
 * JavaScript du tout, tous les avis sont visibles. Textes et nombres dans la langue de la page (window.fsI18n, zone
 * reviews de i18n/reviews.json).
 */
(() => {
  const list = document.querySelector('[data-fs-rp-list]');
  const nav = document.querySelector('[data-fs-rp-pages]');
  const label = document.querySelector('[data-fs-rp-page-label]');
  const title = document.getElementById('fs-rp-list-title');
  if (!list || !nav) return;
  const filters = document.querySelector('[data-fs-rp-filters]');
  const count = document.querySelector('[data-fs-rp-count]');
  const empty = document.querySelector('[data-fs-rp-empty]');
  const emptyText = empty?.querySelector('[data-fs-rp-empty-text]');
  const reset = empty?.querySelector('[data-fs-rp-reset]');
  const size = Math.max(1, parseInt(list.getAttribute('data-fs-rp-size'), 10) || 20);
  const items = [...list.children];
  const games = (list.getAttribute('data-fs-rp-games') || '').split(',').filter(Boolean);
  const GAME_NAMES = { waruniverse: 'WarUniverse', redgalaxy: 'Red Galaxy', darkorbit: 'DarkOrbit', novahorizon: 'Nova Horizon' };
  const reduced = () => window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
  const cardOf = (item) => item.firstElementChild ?? item;
  const i18n = window.fsI18n;
  const t = (key, params) => i18n?.t(`reviews.${key}`, params) ?? key;
  const format = (n) => (i18n ? i18n.number(n) : String(n));

  /* ---- État : filtre et page, lus depuis l'adresse ---- */
  const readFilter = (params) => {
    let note = Math.floor(Number(params.get('note'))) || 0;
    if (note < 1 || note > 5) note = 0;
    const game = games.includes(params.get('jeu')) ? params.get('jeu') : '';
    return { note, game, verified: params.get('verifie') === '1' || Boolean(game) };
  };
  let filter = readFilter(new URLSearchParams(window.location.search));
  const matches = () => items.filter((item) => {
    const card = cardOf(item);
    return (!filter.note || card.getAttribute('data-fs-rating') === String(filter.note))
      && (!filter.verified || card.hasAttribute('data-fs-verified'))
      && (!filter.game || card.getAttribute('data-fs-game') === filter.game);
  });
  const pagesOf = (shown) => Math.max(1, Math.ceil(shown.length / size));
  const clamp = (value, pages) => Math.min(pages, Math.max(1, Math.floor(Number(value)) || 1));

  const hrefFor = (page, next = filter) => {
    const url = new URL(window.location.href);
    if (page === 1) url.searchParams.delete('page');
    else url.searchParams.set('page', String(page));
    if (next.note) url.searchParams.set('note', String(next.note)); else url.searchParams.delete('note');
    if (next.verified && !next.game) url.searchParams.set('verifie', '1'); else url.searchParams.delete('verifie');
    if (next.game) url.searchParams.set('jeu', next.game); else url.searchParams.delete('jeu');
    url.hash = '';
    return `${url.pathname}${url.search}`;
  };

  /** Numéros affichés : premier, dernier, page courante et ses voisines ; null = ellipse. */
  const numbers = (page, pages) => {
    const out = [];
    for (let n = 1; n <= pages; n += 1) {
      if (n === 1 || n === pages || Math.abs(n - page) <= 1) out.push(n);
      else if (out[out.length - 1] !== null) out.push(null);
    }
    return out;
  };

  const link = (page, text, { current = false, rel = '', className = 'fs-pagination-page fs-rp-page' } = {}) => {
    const a = document.createElement('a');
    a.className = className;
    a.href = hrefFor(page);
    a.dataset.fsRpGoto = String(page);
    if (rel) a.rel = rel;
    if (current) { a.classList.add('is-current'); a.setAttribute('aria-current', 'page'); }
    a.append(...text);
    return a;
  };
  const hidden = (text) => { const span = document.createElement('span'); span.className = 'fs-visually-hidden'; span.textContent = text; return span; };
  /** Morceau d'un lien du catalogue : libellé souligné (fs-link-text) ou flèche hors du trait (fs-link-icon). */
  const part = (className, text, decorative = false) => {
    const span = document.createElement('span');
    span.className = className;
    span.textContent = text;
    if (decorative) span.setAttribute('aria-hidden', 'true');
    return span;
  };

  function renderNav(page, pages) {
    const ul = document.createElement('ul');
    ul.className = 'fs-pagination-list fs-rp-pages-list';
    ul.setAttribute('role', 'list');
    const add = (node) => { const li = document.createElement('li'); li.append(node); ul.append(li); };
    if (page > 1) add(link(page - 1, [part('fs-link-icon', '←', true), part('fs-link-text', t('page.newer'))], { rel: 'prev', className: 'fs-btn fs-btn--link' }));
    for (const n of numbers(page, pages)) {
      if (n === null) { const li = document.createElement('li'); li.className = 'fs-pagination-gap fs-rp-page-gap'; li.setAttribute('aria-hidden', 'true'); li.textContent = '…'; ul.append(li); continue; }
      add(link(n, [hidden(`${t('page.page_word')} `), format(n)], { current: n === page }));
    }
    if (page < pages) add(link(page + 1, [part('fs-link-text', t('page.older')), part('fs-link-icon', '→', true)], { rel: 'next', className: 'fs-btn fs-btn--link' }));
    nav.replaceChildren(ul);
    nav.hidden = pages <= 1;
  }

  const stars = (n) => t('stars', { count: n });
  function describe(n) {
    const countText = t('count', { count: n, n: format(n) });
    let text = countText;
    if (filter.note && filter.verified) text = t('page.filter_note_verified', { count_text: countText, stars: stars(filter.note) });
    else if (filter.note) text = t('page.filter_note', { count_text: countText, stars: stars(filter.note) });
    else if (filter.verified) text = t('page.filter_verified', { count_text: countText });
    if (filter.game) text += ` · ${GAME_NAMES[filter.game] ?? filter.game}`;
    return text;
  }

  /* ---- Commandes : puces de filtre ---- */
  const noteButtons = [...(filters?.querySelectorAll('[data-fs-rp-note]') ?? [])];
  const verifiedButton = filters?.querySelector('[data-fs-rp-verified]');
  const gameButtons = [...(filters?.querySelectorAll('[data-fs-rp-game]') ?? [])];
  if (filters) filters.hidden = false;

  function paintControls() {
    noteButtons.forEach((button) => button.setAttribute('aria-pressed', String(Number(button.dataset.fsRpNote || 0) === filter.note)));
    verifiedButton?.setAttribute('aria-pressed', String(filter.verified && !filter.game));
    gameButtons.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.fsRpGame === filter.game)));
  }

  function show(page) {
    const shown = matches();
    const pages = pagesOf(shown);
    const current = clamp(page, pages);
    items.forEach((item) => { item.hidden = true; });
    shown.forEach((item, index) => { item.hidden = index < (current - 1) * size || index >= current * size; });
    list.setAttribute('data-fs-rp-page', String(current));
    if (label) label.textContent = pages > 1 ? ` · ${t('page.page_of', { current: format(current), total: format(pages) })}` : '';
    if (count) count.textContent = describe(shown.length);
    if (empty) {
      empty.hidden = shown.length > 0;
      if (!shown.length && emptyText && reset) {
        if (filter.note) {
          emptyText.textContent = t('page.empty_note', { stars: stars(filter.note) });
          reset.textContent = t('page.reset_ratings');
        } else {
          emptyText.textContent = t('page.empty_verified');
          reset.textContent = t('see_all');
        }
      }
    }
    paintControls();
    renderNav(current, pages);
    return current;
  }

  function go(page) {
    const target = clamp(page, pagesOf(matches()));
    if (target !== (Number(list.getAttribute('data-fs-rp-page')) || 1)) {
      window.history.pushState({ fsReviewsPage: target }, '', hrefFor(target));
    }
    show(target);
    if (title) {
      title.focus({ preventScroll: true });
      title.scrollIntoView({ block: 'start', behavior: reduced() ? 'auto' : 'smooth' });
    }
  }

  function setFilter(next) {
    const wanted = { note: next.note, game: next.game, verified: next.verified || Boolean(next.game) };
    if (wanted.note === filter.note && wanted.game === filter.game && wanted.verified === filter.verified) return;
    filter = wanted;
    window.history.pushState({ fsReviewsPage: 1 }, '', hrefFor(1));
    show(1);
  }

  filters?.addEventListener('click', (event) => {
    const button = event.target.closest?.('button');
    if (!button) return;
    if (button.hasAttribute('data-fs-rp-note')) setFilter({ ...filter, note: Number(button.dataset.fsRpNote || 0) });
    else if (button.hasAttribute('data-fs-rp-verified')) setFilter(filter.verified && !filter.game ? { ...filter, verified: false } : { ...filter, verified: true, game: '' });
    else if (button.hasAttribute('data-fs-rp-game')) setFilter(filter.game === button.dataset.fsRpGame ? { ...filter, game: '', verified: false } : { ...filter, game: button.dataset.fsRpGame, verified: true });
  });
  reset?.addEventListener('click', () => {
    const hadNote = Boolean(filter.note);
    setFilter(hadNote ? { ...filter, note: 0 } : { note: 0, verified: false, game: '' });
    (hadNote ? noteButtons[0] : verifiedButton)?.focus();
  });

  nav.addEventListener('click', (event) => {
    const anchor = event.target.closest?.('a[data-fs-rp-goto]');
    if (!anchor || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    go(Number(anchor.dataset.fsRpGoto));
  });
  window.addEventListener('popstate', () => {
    const params = new URLSearchParams(window.location.search);
    filter = readFilter(params);
    show(params.get('page'));
  });

  // Adresse canonique dès le chargement (?page=99 → dernière page, ?page=1 retiré, filtre inconnu retiré), ancre gardée.
  // Le compteur n'est annoncé qu'après une action : sa zone aria-live n'est posée qu'une fois le premier rendu écrit.
  count?.removeAttribute('aria-live');
  const initial = show(new URLSearchParams(window.location.search).get('page'));
  window.setTimeout(() => count?.setAttribute('aria-live', 'polite'), 0);
  const canonical = hrefFor(initial);
  if (canonical !== `${window.location.pathname}${window.location.search}`) {
    window.history.replaceState(window.history.state, '', `${canonical}${window.location.hash}`);
  }
})();
